<template>
    <!-- Componente para mostrar el mapa del sitio -->
    <section class="site-map container mx-auto pb-8">
        <h1 class="font-medium text-2xl text-center mt-4">Mapa del Sitio</h1>
        <div class="flex flex-wrap justify-between mt-4 sm:mt-6 px-2 sm:px-4 md:px-0">
            <div class="mt-4 mx-2 w-48">
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/`"
                    >Inicio</a></div>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/contacto`"
                    >Contacto</a></div>
                <div v-if="showNews"><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/noticias`"
                    >Noticias</a></div>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/mapa-del-sitio`"
                    >Mapa del Sitio</a></div>
            </div>
            <div class="mt-4 mx-2 w-48">
                <p class="font-medium">Modelos</p>
                <a
                    class="font-medium text-dark-blue"
                    :href="`${url}/${webpage}/modelos`"
                >Todos los modelos</a>
                <div>
                    <a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/modelos/prueba-de-manejo/`"
                    >Prueba de manejo</a>
                </div>
                <p class="font-medium mt-1">Autos</p>
                <div
                    v-for="auto in autos"
                    :key="auto.id"
                >
                    <a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/modelos/configura-una-version/${auto.slug.replaceAll('_', '-')}/f/${auto.year}`"
                    >{{                                                                   auto.name                                                                   }} {{                                                                   auto.year                                                                   }}</a>
                </div>
                <p class="font-medium mt-1">SUV</p>
                <div
                    v-for="s in suv"
                    :key="s.id"
                >
                    <a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/modelos/configura-una-version/${s.slug.replaceAll('_', '-')}/f/${s.year}`"
                    >{{                                                                   s.name                                                                   }} {{                                                                   s.year                                                                   }}</a>
                </div>
            </div>
            <div class="mt-4 mx-2 w-48">
                <p class="font-medium">Servicios</p>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/servicios/agenda-tu-cita`"
                    >Agendar cita</a></div>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/servicios/garantia`"
                    >Garantía</a></div>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/servicios/proteccion-de-llantas`"
                    >Protección de Llantas</a></div>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/servicios/asistencia`"
                    >Asistencia</a></div>
            </div>
            <div class="mt-4 mx-2 w-48">
                <p class="font-medium">Financiamiento</p>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/financiamiento/hyundai-finance`"
                    >Hyundai Finance</a></div>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/financiamiento/hyundai-protect`"
                    >Hyundai Protect</a></div>
            </div>
            <div class="mt-4 mx-2 w-48">
                <p class="font-medium">Legales</p>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/legales/terminos-y-condiciones`"
                    >Términos y Condiciones</a></div>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/legales/aviso-legal`"
                    >Aviso Legal</a></div>
                <div><a
                        class="font-medium text-dark-blue"
                        :href="`${url}/${webpage}/legales/aviso-de-privacidad`"
                    >Aviso de Privacidad</a></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ['categories', 'showNews'],
    data() {
        return {
            url: $('.url').text(),
            webpage: $('.webpage').text(),
        }
    },
    computed: {
        // Retorna el objeto con los autos para cargarlos en
        // el mapa del sitio
        autos() {
            return this.categories.autos
        },
        // Retorna el objeto con los suv para cargarlos en
        // el mapa del sitio
        suv() {
            return this.categories.suv
        }
    }
}
</script>

<style>

</style>